const convertListingToFavourite = (listing) => ({
  id: listing.id,
  title: listing.title,
  artist: listing.artist,
  url: listing.url,
  addCartURL: listing.add_cart_url,
  price: listing.price,
  images: listing.images,
})

export default convertListingToFavourite
